// src/components/filter.
import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, CardBody, Card, Label, Button } from "reactstrap";
//import components
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { AdminService } from "services/AdminService";
import { useFormik } from "formik";
import { DriverSchema } from "schemas/driverSchema";
import { toast } from "react-toastify";
toast.configure();
import "react-toastify/dist/ReactToastify.css";
import { environment } from "environment/environment";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import { AddressModel } from "models/City";
import { Driver } from "models/Driver";
import DriverTableContainer from "components/Common/DriverTableContainer";
import DriverDetailsModal from "modals/DriverDetailsModal";
import UpdateDriver from "./updateDriver";
import Swal from "sweetalert2";
import CustomGooglePlacesAutocomplete from "components/Common/auto-complete";
import { AddressType } from "enum/AddressType";
import "../../assets/css/custom.css";
import { Puff } from "react-loader-spinner";
import { Radio, RadioChangeEvent, Select } from "antd";


interface Day {
    key: string;
    label: string;
  }
  
  const DAYS: Day[] = [
    { key: "sunday", label: "S" },
    { key: "monday", label: "M" },
    { key: "tuesday", label: "T" },
    { key: "wednesday", label: "W" },
    { key: "thursday", label: "T" },
    { key: "friday", label: "F" },
    { key: "saturday", label: "S" },
  ];

const AvailableDrivers: React.FC = () => {
  const [drivers, setDrivers] = useState([] as Driver[]);
  const [driverId, setDriverId] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [LIMIT_P_C, setLIMIT_P_C] = useState(10);

  const mapprops: any = {
    componentRestrictions: { country: "ca" },
    locationRestriction: {
      north: 56.85,    // Northeast corner latitude (Keep this as is)
      south: 41.6,     // Southwest corner latitude (Keep this as is)
      east: -74.0,     // Adjusted Northeast corner longitude to cover Kingston and Cornwall
      west: -95.15     // Keep this as is to cover the entire Ontario province
    }
  };
  const columns = useMemo(
    () => [
      {
        Header: "Driver Id",
        accessor: "customerId",
      },
      {
        Header: "Driver Name",
        accessor: "firstName",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Address",
        accessor: "address.city",
        Cell: ({ row }: any) => {
          const value = row.original.address.city.split(",");
          const count = value.length;
          const city = count - 3 >= 0 ? value[count - 3] : "";
          return city;
        },
      },
      {
        Header: "Phone Number",
        accessor: "phoneNumber",
      },
      {
        id: "action",
        Header: "Availability",
        accessor: "_id",
        Cell: ({ row }: any) => {
          const availableDays = row.original?.availableDays ?? [];
          return (
            <div className="flex flex-md-row gap-2">
              <Row className="d-flex flex-row justify-content-center">
                  {DAYS.map((day, index) => (
                        <Button
                        className="d-flex align-items-center justify-content-center rounded-circle border"
                        style={{
                          minWidth: "32px",
                          maxWidth: "32px",
                          height: "32px",
                          textTransform: "unset",
                          fontSize: "0.75rem",
                          color: availableDays.includes(index) ? "white" : "#f75d21",
                          backgroundColor: availableDays.includes(index) ? "#f75d21" : "white",
                          borderColor: "#f75d21",
                        }}
                        onClick={() => handleToggle(row.original?._id?? "0",index)}
                      >
                      {day.label}
                      </Button>
                  ))}
                  </Row>
              </div>
          );
        },
      },
    ],
    []
  );

  const [isOffset_p_c, setOffset_p_c] = useState<number>(1);
  const [seeMore_p_c, setSeeMore_p_c] = useState(false);
  const [address, setAddress] = useState<AddressModel>();
  const [pageCount, setPageCount] = useState<number>(1);
  const [isloading, setIsloading] = useState<boolean>(true);


  useEffect(() => {
    setIsloading(true);
    AdminService.getDrivers(LIMIT_P_C, isOffset_p_c).then(res => {
      if (res.success) {
        setDrivers(res.data.driverList);
        setSeeMore_p_c(!(res.data.driverList.length > 0 && res.data.driverList.length == LIMIT_P_C));
        setPageCount(Math.ceil(res.data.count / LIMIT_P_C));
      } else {
        setSeeMore_p_c(true);
      }
    });
    setIsloading(false);
  }, [isEditClicked]);

  const SeeMore = (page: any) => {
    setOffset_p_c(page.selected + 1);
    AdminService.getDrivers(LIMIT_P_C, page.selected + 1).then(res => {
      if (res.success) {
        setDrivers(res.data.driverList);
        setSeeMore_p_c(!(res.data.driverList.length > 0 && res.data.driverList.length == LIMIT_P_C));
      } else {
        setSeeMore_p_c(true);
      }
    });
  };



  const handleColumnChange = (selectedOption: any) => {
    setLIMIT_P_C(selectedOption.value);
    AdminService.getDrivers(selectedOption.value, 1).then(res => {
      if (res.success) {
        setDrivers(res.data.driverList);
        setSeeMore_p_c(!(res.data.driverList.length > 0 && res.data.driverList.length == LIMIT_P_C));
        setPageCount(Math.ceil(res.data.count / selectedOption.value));
      } else {
        setSeeMore_p_c(true);
      }
    });
  };


  const searchTable = (serchText: string) => {
    const searchdata = {
      searchableString: serchText,
    };
    AdminService.getDriverBySearch(searchdata, LIMIT_P_C, isOffset_p_c).then(res => {
      if (res.success) {
        if (res.data.length !== 0) {
          setDrivers(res.data);
        }
      }
    });
  };

  // const handleToggle = (driverId: string, index: number) => {
  //   let availableDays: number[] = [];
  
  //   setDrivers((drivers) =>
  //     drivers?.map((driver) => {
  //       if (driver._id === driverId) {
  //         const updatedDays = driver.availableDays?.includes(index)
  //           ? driver.availableDays.filter((day: number) => day !== index) // Remove if exists
  //           : [...(driver.availableDays || []), index]; // Add if not exists
  
  //           availableDays = updatedDays; // Store the updated days for API call
  
  //         return {
  //           ...driver,
  //           availableDays: updatedDays,
  //         };
  //       }
  //       return driver;
  //     })
  //   );
 
  //   AdminService.updateDriverData({ driverId, availableDays }).then((res) => {
  //     if (res.success) {
        
  //     }
  //   });
  // };

    const handleToggle = (driverId: string, index: number) => {
      let availableDays: number[] = [];
  

      Swal.fire({
        title: `Change Availability for Driver?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#F75D21",
        cancelButtonColor: "#A9A9A9",
        confirmButtonText: "Change it!",
      }).then(result => {
        if (result.isConfirmed) {
          setDrivers((drivers) =>
            drivers?.map((driver) => {
              if (driver._id === driverId) {
                const updatedDays = driver.availableDays?.includes(index)
                  ? driver.availableDays.filter((day: number) => day !== index) // Remove if exists
                  : [...(driver.availableDays || []), index]; // Add if not exists
        
                  availableDays = updatedDays; // Store the updated days for API call
        
                return {
                  ...driver,
                  availableDays: updatedDays,
                };
              }
              return driver;
            })
          );
            AdminService.updateDriverData({ driverId, availableDays })
            .then(res => {
              if (res.success) {
                Swal.fire({
                  icon: "success",
                  text: `Added Changes`,
                  confirmButtonColor: "#F75D21",
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: res.error,
                  confirmButtonColor: "#F75D21",
                });
              }
            })
            .catch(error => {
              console.error(error);
            });
          // } else {
          //   Swal.fire({
          //     icon: "error",
          //     title: "There are some pending payments, Please try again after settle it down.",
          //     confirmButtonColor: "#F75D21",
          //   });
          // }
          // });
        }
      });
    };

  //meta title
  document.title = "Available Drivers";

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Available Drivers" breadcrumbItem={"Update"} />
        <Col lg={12}>
          <Card>
            <CardBody>
              <div>Available Driver List</div>
              {isloading? <div className="d-flex justify-content-center align-items-center"  style={{ height: '500px' }}>
                  <Puff color="#FFD0B8" height={50} width={50} />
                </div>:
              <>{drivers.length > 0 ? (
                <DriverTableContainer
                  columns={columns}
                  data={drivers}
                  currentPage={isOffset_p_c}
                  pagelimit={pageCount}
                  handlePageChange={SeeMore}
                  handleSearch={searchTable}
                  handleColumnChange={handleColumnChange}
                  selectedColumns={LIMIT_P_C}
                  isGlobalFilter={true}
                  isAddOptions={false}
                  customPageSize={50}
                  className="custom-header-css"
                  isJobListGlobalFilter={undefined}
                  isAddUserList={undefined}
                  handleOrderClicks={undefined}
                  handleUserClick={undefined}
                  handleCustomerClick={undefined}
                  isAddCustList={undefined}
                  customPageSizeOptions={undefined}
                  isPDFGenerate={true}
                  ispopup={true}
                  isAddressBook={false}
                  hancleDeleteRecords={undefined}
                  handleSelect={undefined}
                  selectedID={undefined}
                  isABusiness={true}
                />
              ) : (
                <Row className="justify-content-md-center justify-content-center align-items-center">
                  <Col className="col-md-auto">
                    <div>No Drivers to show</div>
                  </Col>
                </Row>
              )}</>}
            </CardBody>
          </Card>
        </Col>
      </div>
    </div>
  );
};

export default AvailableDrivers;








































// const AvailableDrivers: React.FC = () => {

//   const [isOffset_p_c, setOffset_p_c] = useState<number>(1);
//   const [customers, setCustomers] = useState<Driver[]>();
//   const [LIMIT_P_C, setLIMIT_P_C] = useState(1000);
//   const [isloading, setIsloading] = useState<boolean>(true);
//   const [selectedDays, setSelectedDays] = useState<number[]>([0, 2, 3]);

//   useEffect(() => {
//     getPendingUsers('');
//   }, []);

//   const getPendingUsers = (searchText: string) => {
//     const searchdata = {
//       searchableString: searchText,
//     };

//     AdminService.getDriverBySearch(searchdata, LIMIT_P_C, isOffset_p_c).then(res => {
//       if (res.success) {
//         setCustomers(res?.data);
//         //   setPageCount(Math.ceil(res.data.count / LIMIT_P_C));
//         setIsloading(false)
//       }
//       setIsloading(false)
//     });
//   };

//   const handleToggle = (driverId: string, index: number) => {
//     let availableDays: number[] = [];
  
//     setCustomers((customers) =>
//       customers?.map((user) => {
//         if (user._id === driverId) {
//           const updatedDays = user.availableDays?.includes(index)
//             ? user.availableDays.filter((day: number) => day !== index) // Remove if exists
//             : [...(user.availableDays || []), index]; // Add if not exists
  
//             availableDays = updatedDays; // Store the updated days for API call
  
//           return {
//             ...user,
//             availableDays: updatedDays,
//           };
//         }
//         return user;
//       })
//     );
//     console.log(availableDays);
    
//     AdminService.updateDriverData({ driverId, availableDays }).then((res) => {
//       if (res.success) {
        
//       }
//     });
//   };


//   document.title = "Available Drivers | Zulu Courier"


//   return (
//     <React.Fragment>
//       <div className="page-content">
//         <div className="container-fluid">
//           <Breadcrumb title="Users" breadcrumbItem="Non-Verified Users" />
//           <Col lg={12}>
//             <Card>
//               <CardBody>
//                 {isloading ? <div className="d-flex justify-content-center align-items-center" style={{ height: '500px' }}>
//                   <Puff color="#FFD0B8" height={50} width={50} />
//                 </div> :
//                   <>
//                     {customers && customers?.length > 0 ? (
//                       <div className="table-responsive react-table mx-lg-1 px-lg-2 small mt-2">
//                         <table className="newTable">
//                           <thead className="newThead">
//                             <tr>
//                               <th className="text-sm-nowrap">Driver Id</th>
//                               <th className="text-sm-nowrap">First Name</th>
//                               <th className="text-sm-nowrap">Email Address</th>
//                               <th className="text-sm-nowrap">Phone Address</th>
//                               <th className="text-sm-nowrap d-flex flex-row justify-content-center">Available Days</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {customers?.map((user: Driver) => {
//                              const availableDays = user?.availableDays ?? [];
//                               return (
//                                 <tr key={user._id}>
//                                   <td data-label="Driver Id">{user?.customerId}</td>
//                                   <td data-label="First Name">{user?.firstName}</td>
//                                   <td data-label="Email Address">{user?.email}</td>
//                                   <td data-label="Phone Address">{user?.phoneNumber}</td>
//                                   <td data-label="Available Days">
//                                     <div className="flex flex-md-row gap-2">
//                                     <Row className="d-flex flex-row justify-content-center">
//                                         {DAYS.map((day, index) => (
//                                              <Button
//                                              className="d-flex align-items-center justify-content-center rounded-circle border"
//                                              style={{
//                                                minWidth: "32px",
//                                                maxWidth: "32px",
//                                                height: "32px",
//                                                textTransform: "unset",
//                                                fontSize: "0.75rem",
//                                                color: availableDays.includes(index) ? "white" : "#f75d21",
//                                                backgroundColor: availableDays.includes(index) ? "#f75d21" : "white",
//                                                borderColor: "#f75d21",
//                                              }}
//                                              onClick={() => handleToggle(user._id?? "0",index)}
//                                            >
//                                             {day.label}
//                                             </Button>
//                                         ))}
//                                         </Row>
//                                     </div>
//                                   </td>
//                                 </tr>
//                               );
//                             })}
//                           </tbody>
//                         </table>
//                       </div>
//                     ) : (
//                       <Row className="justify-content-md-center justify-content-center align-items-center">
//                         <Col className="col-md-auto">
//                           <div>No Non-Verified Users</div>
//                         </Col>
//                       </Row>
//                     )}
//                   </>}
//               </CardBody>
//             </Card>
//           </Col>
//         </div>
//       </div>
//     </React.Fragment>
//   )
// }

// export default AvailableDrivers